















































































import {Prop, Watch} from "vue-property-decorator";
import {Component, Vue} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';
import {Fournisseur, Contact, Client} from '@/models';

import storeContact from '@/stores/modules/contact';

import InputPhone from '@/components/Input/Phone.vue';
import CrudFournisseurSearch from '@/components/Crud/Fournisseur/Search.vue';
import CrudClientSearch from '@/components/Crud/Client/Search.vue';

@Component({
	components: {
		InputPhone,
		CrudFournisseurSearch,
		CrudClientSearch,
	}
})
export default class CrudContactEdit extends AbstractEditVue<Contact> {
	@Prop({ type: Fournisseur, default: null}) fournisseur: Fournisseur;
	@Prop({ type: Client, default: null}) client: Client;

	public constructor() {
		super(
			storeContact,
			'Contact modifié',
			'Contact créé',
		);
	}

	@Watch('fournisseur')
	@Watch('client')

	public contratWatcher(): void {
		if (this.fournisseur && this.item) {
			this.item.fournisseur = this.fournisseur;
		}
		if (this.client && this.item) {
			this.item.client = this.client;
		}
	}

	protected async refresh(): Promise<void> {
		await super.refresh();
		if (this.fournisseur) {
			this.item.fournisseur = this.fournisseur;
		}
		if (this.client) {
			this.item.client = this.client;
		}
	}

}
